import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RAW_BASE = process.env.REACT_APP_API_BASE || '/api';
const API_BASE = RAW_BASE.replace(/["']/g, '').replace(/\/+$/, '');

// Option 1: If you put the image in public folder (recommended)
// const logoUrl = '/han-han-lao-shi-logo.jpg';

// Option 2: Import the image (if you put it in src/assets)
// import logo from './assets/han-han-lao-shi-logo.jpg';

export default function Login() {
  const [role, setRole] = useState('student');
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); 
    setError('');

    try {
      let res;
      if (role === 'tutor') {
        res = await fetch(`${API_BASE}/tutor/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: identifier, password }),
          credentials: 'include'
        });
      } else {
        res = await fetch(`${API_BASE}/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ identifier, password, role }),
          credentials: 'include'
        });
      }

      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data.error || 'Login failed');
      }

      if (data.token) {
        localStorage.setItem('token', data.token);
      }
      
      if (data.user) {
        localStorage.setItem('user', JSON.stringify(data.user));
      }

      if (data.user?.role === 'admin') {
        navigate('/admin/dashboard');
      } else if (data.user?.role === 'parent') {
        navigate('/parent/dashboard');
      } else if (data.user?.role === 'tutor') {
        navigate('/tutor/dashboard');
      } else {
        navigate('/student/dashboard');
      }
      
    } catch (err) {
      setError(err.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      maxWidth: 450, 
      margin: '40px auto', 
      padding: '24px 20px', 
      border: '1px solid #ddd', 
      borderRadius: 10, 
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      minHeight: 'calc(100vh - 80px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }}>
      {/* Logo Section - Mobile Friendly */}
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img 
          src="/HanEdu-BigLogo.jpeg" // Update this path to where you store the logo
          alt="Han Han Lao Shi"
          style={{ 
            maxWidth: '100%', 
            width: '280px', 
            height: 'auto',
            display: 'block',
            margin: '0 auto'
          }}
        />
      </div>
      
      {error && (
        <div style={{ 
          padding: 10, 
          background: '#f8d7da', 
          color: '#721c24', 
          borderRadius: 6, 
          marginBottom: 15, 
          fontSize: 14,
          border: '1px solid #f5c6cb'
        }}>
          ⚠️ {error}
        </div>
      )}
      
      <form onSubmit={handleLogin}>
        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 }}>Role</label>
        <select
          value={role}
          onChange={(e) => {
            setRole(e.target.value);
            setIdentifier('');
          }}
          style={{ width: '100%', padding: 10, marginBottom: 12, borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}
        >
          <option value="student">Student</option>
          <option value="parent">Parent</option>
          <option value="tutor">Tutor</option>
          <option value="admin">Admin</option>
        </select>
        
        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 }}>
          {(role === 'parent' || role === 'tutor') ? 'Email Address' : 'Username'}
        </label>
        <input
          type={(role === 'parent' || role === 'tutor') ? 'email' : 'text'}
          placeholder={(role === 'parent' || role === 'tutor') ? 'Enter your email' : 'Enter username'}
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          required
          style={{ width: '100%', padding: 10, marginBottom: 12, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }}
        />
        
        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 }}>Password</label>
        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: '100%', padding: 10, marginBottom: 16, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }}
        />
        
        <button
          type="submit"
          disabled={loading}
          style={{ 
            width: '100%', 
            padding: 12, 
            background: '#007BFF', 
            color: '#fff', 
            border: 'none', 
            borderRadius: 6, 
            cursor: loading ? 'not-allowed' : 'pointer', 
            fontSize: 16, 
            fontWeight: 500,
            opacity: loading ? 0.7 : 1,
            transition: 'opacity 0.2s'
          }}
        >
          {loading ? '⏳ Logging in...' : 'Login'}
        </button>
      </form>
      
      <div style={{ marginTop: 20, textAlign: 'center', fontSize: 12, color: '#666' }}>
        <p>Demo credentials:</p>
        <p>Student: <code>student1 / password</code></p>
        <p>Parent: <code>parent@test.com / password</code></p>
        <p>Admin: <code>admin / admin123</code></p>
      </div>
    </div>
  );
}